export default "6108b55a6e5b8072.svg"